module.exports = __webpack_public_path__ + "static/img/content-header.34f95e0d.svg";